import { Layout } from "./components/Layout";
import { CalculatorPage } from "./pages/CalculatorPage";
import { MethodologyPage } from "./pages/MethodologyPage";
import { PrivacyPage } from "./pages/PrivacyPage";
import { SavedCalculationsPage } from "./pages/SavedCalculationsPage";
import { TermsPage } from "./pages/TermsPage";
import { useNavigation } from "./router-context";

export default function App() {
  const { path } = useNavigation();
  const page = (() => {
    switch (path) {
      case "/":
        return <CalculatorPage />;
      case "/mis-calculos":
        return <SavedCalculationsPage />;
      case "/metodologia":
        return <MethodologyPage />;
      case "/privacidad":
        return <PrivacyPage />;
      case "/terminos":
        return <TermsPage />;
      case "/auth/callback":
        return <div className="empty-state">Iniciando sesión…</div>;
      default:
        return <CalculatorPage />;
    }
  })();

  return (
    <Layout>{page}</Layout>
  );
}
